import { HttpService } from '@/data/http/http-service';
import {
  EnvQuestions,
  EnvQuestionValue,
} from '@/domain/impact-env/entities/question.entity';
import { ImpactEnvGateway } from '@/domain/impact-env/gateways/impact-env.gateway';
import { ModelVersionENV } from '@/domain/project/entities/project.entity';

import {
  getImpactAnswersResponsesDtoSchema,
  getModelParametersDtoSchema,
} from './impact-env.dto.schema';

export class ApiImpactEnvHttpGateway implements ImpactEnvGateway {
  private http = new HttpService({
    baseURL: import.meta.env.VITE_API_IMPACT,
  });

  async getImpactEnvQuestions(modelVersion: string): Promise<EnvQuestions> {
    const url = '/model-parameters/env';
    const options = { additionalHeaders: { 'x-model-version': modelVersion } };
    const response = await this.http.get(url, options);
    const result = getModelParametersDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const modelParameters: EnvQuestions = result.data;
    return modelParameters;
  }

  async getImpactEnvResponses(projectId: number): Promise<EnvQuestionValue[]> {
    const url = `/env-values?projectId=${projectId}`;
    const response = await this.http.get(url);
    const result = getImpactAnswersResponsesDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const responses: EnvQuestionValue[] = result.data;
    return responses;
  }

  async createImpactEnvResponse(
    projectId: number,
    paramId: string,
    value: string,
    modelVersion: ModelVersionENV,
  ): Promise<void> {
    const url = '/env-values';
    const data = {
      paramId: paramId,
      value: value,
      projectId: projectId,
      modelVersion,
    };
    await this.http.post(url, data);
  }

  async editImpactEnvResponse(answerId: number, value: string): Promise<void> {
    const url = `/env-values/${answerId}`;
    const data = { value };
    await this.http.patch(url, data);
  }
}
